module.exports = __webpack_public_path__ + "img/6.1d2ac0e1.jpg";